module.exports = __webpack_public_path__ + "static/media/t-2-q-9-1.fbb9e8e0.png";